if (!customElements.get('apria-direct-redirect')) {
  class ApriaDirectRedirect extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      const form = this.closest('form');
      if (!form) {
        return;
      }

      this.notice = this.querySelector('.ad-redirect-notice');
      this.submitBtn = form.querySelector('[name="add"]');
      this.redirectBtn = form.querySelector('.js-ad-redirect-btn');
      this.qtyInput = form.querySelector('quantity-input');
      this.payBtn = form.querySelector('.shopify-payment-button');
      this.variants = this.getVariantData();

      const productInfo = this.closest('.product-info');
      const variantPicker = productInfo ? productInfo.querySelector('variant-picker') : null;
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.update(this.dataset.active === 'true');
    }

    /**
     * Gets the inventory data for all product variants, keyed by variant id
     * @returns {?Map}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      const variants = JSON.parse(dataEl.textContent);
      return new Map(variants.map((variant) => [variant.id, variant]));
    }

    /**
     * Handles a 'on:variant:change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (!evt.detail.variant) {
        this.update(false);
        return;
      }

      const variant = this.variants.get(evt.detail.variant.id);
      this.update(variant !== undefined && variant.available === false && variant.inventory_policy === 'deny');
    }

    /**
     * Swaps the add-to-cart UI for the ApriaDirect redirect UI and back
     * @param {boolean} active - whether the redirect UI should show
     */
    update(active) {
      this.dataset.active = active ? 'true' : 'false';

      if (this.notice) {
        this.notice.hidden = !active;
      }
      if (this.redirectBtn) {
        this.redirectBtn.hidden = !active;
      }
      if (this.submitBtn) {
        this.submitBtn.hidden = active;
      }
      if (this.qtyInput) {
        this.qtyInput.hidden = active;
      }
      if (this.payBtn) {
        this.payBtn.hidden = active;
      }
    }
  }

  customElements.define('apria-direct-redirect', ApriaDirectRedirect);
}
